module.exports = __webpack_public_path__ + "static/media/facebook.3fb1b10e.svg";